import store from '@/store'
import roles from '@/components/constants/roles'

const routeRole = {
  // route name / roles
  examplesTab: [
    '2778',
    '2779',
    '2780',
    '2781',
    '2782',
    '2783',
    '2784',
    '2785',
    '2786',
    '2787',
    '2788',
  ],
  // documents
  journalReceived: ['2780'],
  adminJournalReceivedForm: ['2780'],
  journalCheckingForm: ['2780'],
  journalNotification: ['2780'],
  // search
  searchNew: ['2778', '2780', '2781', '2782', '2783', '2784', '2785', '2786', '2787', '2788'],
  adminOrderForm: ['2778', '2780', '2781', '2782', '2783', '2784', '2785', '2786', '2787', '2788'],
  adminOrderFormList: ['2778', '2780', '2781', '2782', '2783', '2784', '2785', '2786', '2787', '2788'],
  searchList: ['2778', '2780', '2781', '2782', '2783', '2784', '2785', '2786', '2787', '2788'],
  searchOrders: ['2778', '2780'],
  // classifier
  classifierServices: ['2779'],
  adminServiceForm: ['2779'],
  classifierMandateTypes:['2779'],
  adminTooltipForm: ['2779'],
  classifierInstitutionsGroups: ['2779'],
  adminInstitutionGroupForm: ['2779'],
  classifierRejectReasons: ['2779'],
  classifierEmailAndSMS: ['2779'],
  adminRejectReasonForm: ['2779'],
  classifierErrorNotifications: ['2779'],
  adminErrorNotificationForm: ['2779'],
  classifierSecurityNotifications: ['2779'],
  adminSecurityNotificationForm: ['2779'],
  classifierTooltips: ['2779'],
  adminSystemNotifications: ['2779'],
  adminSystemBlacklist: ['2779'],
  adminTooltipForm: ['2779'],
  classifierAuthorizingPersons: roles.SUTARTINIAI,
  adminAuthorizingPersonForm: roles.SUTARTINIAI,
  // admin
  adminParameters: ['2779'],
  adminData: ['2779'],
  adminRecords: ['2779'],
  // reports
  reports:['2780'],
  // messages
  adminMessagesPreparedSent:['2780', '2791', '2792', '2793', '2794', '2795', '2796'], //2779
  adminMessageNew:['2780', '2791', '2792', '2793', '2794', '2795', '2796'], //2779
  adminMessageListNew:['2780', '2791', '2792', '2793', '2794', '2795', '2796'],
  adminRequestsPreparedSent:['2779','2780','2778'],
  adminRequestNew:['2779','2780','2778'],
  adminRequestListNew:['2779','2780','2778'],
  // object data change
  adminObjectDataChange:[roles.IR_REGISTRATORIUS, roles.NOTARAS, roles.KONSULAS, roles.NOT_PAD, roles.KAL_VAD, roles.NOT_PAD2],
  adminObjectDataChangeForm:[roles.IR_REGISTRATORIUS, roles.NOTARAS, roles.KONSULAS, roles.NOT_PAD, roles.KAL_VAD, roles.NOT_PAD2],
  // archive
  adminObjectArchive:['2780'],
  adminDestroyedObjectsList:['2780'],
  adminDataDestructionActs:['2780'],
  // home
  home: null,
}

export function getRouteRole(routeName) {
  return routeRole[routeName]
}
export function authRoute(routeName) {
  const userRole = store.getters.userRole
  const checkRole = getRouteRole(routeName)
  if (!checkRole) {
    return true
  }

  return checkRole.some((item) => {
    return userRole.includes(item)
  })
}
